if (
  window.self !== window.top &&
  window.location.search.includes('builder_m_p=yes')
) {
  window.addEventListener('message', (e) => {
    if (e.data.type === 'syncScroll') {
      const { ratio } = e.data.detail

      const scrollHeight = document.documentElement.scrollHeight
      const clientHeight = document.documentElement.clientHeight
      const targetScroll = ratio * (scrollHeight - clientHeight)

      window.__syncingScroll = true
      document.documentElement.scrollTop = targetScroll
      document.body.scrollTop = targetScroll

      setTimeout(() => {
        window.__syncingScroll = false
      }, 1500)
    }
  })

  window.addEventListener('scroll', () => {
    if (window.__syncingScroll) return

    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight
    const ratio = scrollTop / (scrollHeight - clientHeight)

    window.parent.postMessage(
      {
        type: 'syncScroll',
        purpose: 'syncScroll',
        detail: { ratio },
      },
      '*'
    )
  })
}
